import styled from 'styled-components'

export const CFlatListSection = styled.div`
	width: 100%;
	height: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: row;
`
